<template>
  <div v-if="isClick" class="popup-cover">
    <div class="cover" @click="onClickBtn"></div>
    <div class="popup">
      <div class="aaaa">
        <img
          v-if="value !== null"
          :src="require(`@/assets/img/${value.img}.png`)"
          :alt="value.title + ' - ' + value.vtn"
        />
      </div>
      <div class="label">
        <h2>{{ value.title }}</h2>
        <button @click="onClickBtn">닫기</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "List",
  props: {
    value: Object,
    isClick: Boolean,
  },
  methods: {
    onClickBtn() {
      this.$emit("onClickBtn", false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/utils/scss/fluid-typo.scss";

.popup-cover {
  z-index: 1000;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(#2d2a29, 0.8);
}
.cover {
  z-index: 1;
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
}
.popup {
  position: fixed;
  z-index: 10;
  left: 20vw;
  top: 50%;
  transform: translateY(-50%);
  width: 60vw;
  height: auto;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;

  .aaaa {
    min-height: 60vw;
  }

  .label {
    h2 {
      position: absolute;
      top: 0;
      left: 0;
      min-width: 60px;
      padding: 10px;
      margin: 0;
      font-size: 16px;
      text-align: center;
      border-radius: 8px;
      background: blanchedalmond;
      word-break: keep-all;
      border-radius: 0 0 10px 0;
      box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.2);
    }
  }

  button {
    background: #efeaea;
    border: 0;
    width: 100%;
    margin: 0 auto;
    font-size: 16px;
    display: block;
    font-weight: bold;
    color: #6a615f;
    padding: 12px 0;
  }

  img {
    display: block;
    width: 100%;
    height: auto;
  }
}

@media screen and (min-width: 1200px) {
  .popup {
    left: 30vw;
    width: 40vw;

    .aaaa {
      min-height: 40vw;
    }
  }
}
</style>
